import "bootstrap/dist/css/bootstrap.min.css";
import "../src/Assests/css/main.css";
import "swiper/swiper-bundle.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

import { lazy, Suspense, useEffect, useMemo, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer } from "react-toastify";

import {
  get_seo_data_website,
  server_post_data,
} from "./ServiceConnection/serviceconnection";
import { HistoryProvider } from "./Components/Sections/HistoryContext";
import ScrollToTop from "./CommonJquery/ScrollToTop";

const Home = lazy(() => import("./Components/Pages/Home"));
const About = lazy(() => import("./Components/Pages/About"));
const AplicationForm = lazy(() => import("./Components/Pages/AplicationForm"));
const BlogDetails = lazy(() => import("./Components/Pages/BlogDetails"));
const Blogs = lazy(() => import("./Components/Pages/Blogs"));
const CarDetail = lazy(() => import("./Components/Pages/CarDetails"));
const Contact = lazy(() => import("./Components/Pages/Contact"));
const Favorites = lazy(() => import("./Components/Pages/Favorites"));
const Listing = lazy(() => import("./Components/Pages/Listing"));
const Login = lazy(() => import("./Components/Pages/Login"));
const Profile = lazy(() => import("./Components/Pages/Profile"));
const ResetPassword = lazy(() => import("./Components/Pages/ResetPassword"));
const Services = lazy(() => import("./Components/Pages/Services"));
const MyBookings = lazy(() => import("./Components/Pages/MyBookings"));
const Maintenance = lazy(() => import("./Components/Pages/Maintenance"));
const Agreement = lazy(() => import("./Components/Pages/Agreement"));
const StripeCheckout = lazy(() => import("./Components/Pages/StripeCheckout"));
const PaymentPage = lazy(() => import("./Components/Pages/paymnet"));
const AccidentPage = lazy(() => import("./Components/Pages/AccidentPage"));
const PrimaryPolicyNew = lazy(() =>
  import("./Components/Pages/PrimaryPolicyNew")
);
const TermsOfUseNew = lazy(() => import("./Components/Pages/TermsOfUseNew"));
const BalanceScreen = lazy(() => import("./Components/Pages/BalanceScreen"));
const DepositBalanceScreen = lazy(() =>
  import("./Components/Pages/DepositBalanceScreen")
);
const SuccessCheckout = lazy(() =>
  import("./Components/Pages/SuccessCheckout")
);
const SuccessCheckoutDeposit = lazy(() =>
  import("./Components/Pages/SuccessCheckoutDeposit")
);
const PaymentUnsuccessful = lazy(() =>
  import("./Components/Pages/PaymentUnsuccessful")
);
const AdversitePage = lazy(() => import("./Components/Pages/AdversitePage"));
const ThankYou = lazy(() => import("./Components/Pages/ThankYou"));
const DriverAccount = lazy(() => import("./Components/Pages/DriverAccount"));
const NotFound = lazy(() => import("./Components/Pages/NotFound"));

function App() {
  const [SEOloop, setSEOloop] = useState([]);

  const match_and_return_seo_link_and_page = (
    call_function_name,
    pretty_function_name,
    dynamic_title_ss,
    favicon_sss
  ) => {
    let data_seo_link_final = "";

    if (call_function_name === "/") {
      data_seo_link_final = pretty_function_name + "~@~1";
    } else if (call_function_name === "/login") {
      data_seo_link_final = pretty_function_name + "~@~2";
    } else if (call_function_name.includes("Listing")) {
      data_seo_link_final = pretty_function_name + "~@~3";
    } else if (call_function_name === "/contact") {
      data_seo_link_final = pretty_function_name + "~@~4";
    } else if (call_function_name === "/about") {
      data_seo_link_final = pretty_function_name + "~@~5";
    } else if (call_function_name === "/services") {
      data_seo_link_final = pretty_function_name + "~@~6";
    } else if (call_function_name === "/blog") {
      data_seo_link_final = pretty_function_name + "~@~7";
    } else if (call_function_name === "/terms-of-use") {
      data_seo_link_final = pretty_function_name + "~@~8";
    } else if (call_function_name === "/privacy-policy") {
      data_seo_link_final = pretty_function_name + "~@~9";
    } else if (call_function_name.includes("/cars/car_details/")) {
      data_seo_link_final = pretty_function_name + "~@~10";
    } else if (call_function_name.includes("Blogs/blogdetail/")) {
      data_seo_link_final = pretty_function_name + "~@~11";
    }
    return data_seo_link_final;
  };

  const get_page_name = (page_number) => {
    let data_seo_link_final = "";

    if (page_number === "1") {
      data_seo_link_final = <Home />;
    } else if (page_number === "2") {
      data_seo_link_final = <Login />;
    } else if (page_number === "3") {
      data_seo_link_final = <Listing />;
    } else if (page_number === "4") {
      data_seo_link_final = <Contact />;
    } else if (page_number === "5") {
      data_seo_link_final = <About />;
    } else if (page_number === "6") {
      data_seo_link_final = <Services />;
    } else if (page_number === "7") {
      data_seo_link_final = <Blogs />;
    } else if (page_number === "8") {
      data_seo_link_final = <TermsOfUseNew />;
    } else if (page_number === "9") {
      data_seo_link_final = <PrimaryPolicyNew />;
    } else if (page_number === "10") {
      data_seo_link_final = <CarDetail />;
    } else if (page_number === "11") {
      data_seo_link_final = <BlogDetails />;
    }

    return data_seo_link_final;
  };

  const handleFetchData = async () => {
    await server_post_data(get_seo_data_website, null)
      .then((Response) => {
        if (Response.error) {
          //handleError(Response.message);
        } else {
          setSEOloop(Response.message.seo_loop);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    handleFetchData();
  }, []);
  const dynamicRoutes = useMemo(() => {
    try {
      // Defensive programming: Add error handling
      if (!SEOloop || SEOloop.length === 0) {
        console.warn("SEOloop is empty or undefined");
        return [];
      }

      return SEOloop.map((data, index) => {
        try {
          // Safe route generation with extensive error checking
          const for_loop_come = match_and_return_seo_link_and_page(
            data.call_function_name,
            data.pretty_function_name,
            data.title,
            data.favicon
          );
          if (!for_loop_come) {
            return null;
          }

          const stringArray = for_loop_come.split("~@~");

          // Validate route parts
          if (stringArray.length < 2) {
            return null;
          }

          return (
            <Route
              key={index}
              path={stringArray[0]}
              element={get_page_name(stringArray[1])}
            />
          );
        } catch (routeError) {
          return null;
        }
      }).filter((route) => route !== null);
    } catch (error) {
      return [];
    }
  }, [SEOloop]); // Dependency on SEOloop

  return (
    <BrowserRouter>
      {" "}
      <ScrollToTop />
      <HistoryProvider>
        <Suspense fallback={<div className="text-center p-5"></div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/" element={<Loader />} /> */}
            <Route
              path="/login"
              element={
                <GoogleOAuthProvider clientId="166804490112-bvhkf2hulsrea4499d7pf5jgh2sjnchm.apps.googleusercontent.com">
                  <Login />
                </GoogleOAuthProvider>
              }
            />

            {/* <Route path="/reset_password" element={<ResetPassword />} /> */}
            <Route path="/Listing" element={<Listing />} />

            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/blog" element={<Blogs />} />

            <Route path="/terms-of-use" element={<TermsOfUseNew />} />
            <Route path="/privacy-policy" element={<PrimaryPolicyNew />} />
            <Route path="/application_form" element={<AplicationForm />} />
            <Route path="/trip_details" element={<Maintenance />} />
            <Route path="/driver_accounts" element={<DriverAccount />} />
            <Route path="/trip_details/:id" element={<Maintenance />} />
            <Route path="/agreement" element={<Agreement />} />

            <Route path="/cars/car_details/:id" element={<CarDetail />} />
            <Route path="/Blogs/blogdetail/:id" element={<BlogDetails />} />

            <Route path="/Profile" element={<Profile />} />
            <Route path="/reset_password/:id" element={<ResetPassword />} />
            <Route path="/favourite" element={<Favorites />} />
            <Route path="/stripe_checkout" element={<StripeCheckout />} />
            <Route path="/my_bookings" element={<MyBookings />} />
            <Route path="/payment_link" element={<PaymentPage />} />
            <Route path="/accident_page" element={<AccidentPage />} />
            <Route path="/totalBalance" element={<BalanceScreen />} />
            <Route
              path="/totalDepoitBalance"
              element={<DepositBalanceScreen />}
            />
            <Route path="/success" element={<SuccessCheckout />} />
            <Route
              path="/depositsuccess"
              element={<SuccessCheckoutDeposit />}
            />
            <Route
              path="/payment-unsuccess"
              element={<PaymentUnsuccessful />}
            />
            <Route path="/rideshare-car-rentals" element={<AdversitePage />} />
            <Route path="/Thank-you" element={<ThankYou />} />
            {dynamicRoutes}
            {dynamicRoutes && dynamicRoutes.length && (
              <Route path="/*" element={<NotFound />} />
            )}
          </Routes>
        </Suspense>
      </HistoryProvider>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
